/**
 * HTML5 Audio Visualizer API
 * HTML5音频频谱可视化API
 * Author：PoppinRubo
 * License: MIT
 */

//创建一个对象方法
export default function Visualizer() {
    //先把自己用变量储存起来,后面要用
    var Myself = this;
    //频谱配置,外部调用就开始进行处理
    this.config = function (cfg) {
        Myself.audioUrl = cfg.audioUrl;
        Myself.container = cfg.container;
        Myself.draw = cfg.draw;
        _windowAudioContext();
    }
    //下面这些为内部方法,外部不可访问

    //实例化一个音频类型window.AudioContext
    function _windowAudioContext() {
        //下面这些是为了统一Chrome和Firefox的AudioContext
        window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
        window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame;
        window.cancelAnimationFrame = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame;
        try {
            Myself.audioContext = new AudioContext();
            //AudioContext实例化后就拉取音频
            _loadSound();
        } catch (e) {
            console.log(e + ',您的浏览器不支持 AudioContext');
        }
    }

    //加载音频对象方法
    function _loadSound() {
        var request = new XMLHttpRequest(); //建立一个请求
        request.open('GET', Myself.audioUrl, true); //配置请求类型，文件路径,路径不可跨域
        request.responseType = 'arraybuffer'; //配置数据返回类型
        request.onload = function () {
            //拉取成功返回ArrayBuffer(一块内存空间,缓冲),调用播放
            _play(request.response);
        }
        request.send();
    }

    //解码播放,提取数据
    function _play(audioData) {
        var audioContext = Myself.audioContext;
        //解码ArrayBuffer
        audioContext.decodeAudioData(audioData).then(function (decodedData) {
            //进来到这里代表解码完成
            //AudioBuffer接口表示存在存储器里的短音频资产，利用AudioContext.decodeAudioData()方法从音频文件构建，
            // 或者利用 AudioContext.createBuffer()构建于原数据。
            // 一旦将其放入AudioBuffer，可以传递到一个 AudioBufferSourceNode 进行播放
            var audioBufferSouceNode = audioContext.createBufferSource(),
                analyser = audioContext.createAnalyser();
            // 循环播放
            audioBufferSouceNode.loop = true
            //将source与分析器连接
            audioBufferSouceNode.connect(analyser);
            //将分析器与destination连接，形成到达扬声器的通路
            // analyser.connect(audioContext.destination);
            //将上面解码得到的decodedData数据赋值给source
            audioBufferSouceNode.buffer = decodedData;
            //播放,到这里就可以听到声音了
            audioBufferSouceNode.start(0);
            //接下来把分析器传出去创建频谱
            _initCanvas(analyser);
        }, function (e) {
            console.log(e + ",文件解码失败!");
        });

    }
    // 创建画布
    function _initCanvas(analyser) {
      var canvas = document.createElement('canvas')
      var container = Myself.container
      canvas.width = container.offsetWidth
      canvas.height = container.offsetHeight
      container.appendChild(canvas)
      _draw(canvas, analyser)
    }
    // 画形状 （可以自定义）
    function _draw (canvas, analyser) {
      if (Myself.draw) {
        Myself.draw(canvas, analyser)
      } else {
        _defaultDraw(canvas, analyser)
      }
    }
    // 默认形状
    function _defaultDraw (canvas, analyser) {
      var meterWidth = 10, gap = 2;//频谱条宽度、间距
      var capHeight = 2;
      var capStyle = '#fff';
      var cwidth = canvas.width;
      var cheight = canvas.height - gap;

      var meterNum = cwidth / (meterWidth + gap); //频谱条数量 
      var capYPositionArray = []; //将上一画面各帽头的位置保存到这个数组

      var ctx = canvas.getContext('2d');

      var drawMeter = function () {
        var array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        var step = Math.round(array.length / meterNum); //计算采样步长
        ctx.clearRect(0, 0, cwidth, cheight);
        for (var i = 0; i < meterNum; i++) {
            var value = array[i * step]; //获取当前能量值
            if (capYPositionArray.length < Math.round(meterNum)) {
                capYPositionArray.push(value); //初始化保存帽头位置的数组，将第一个画面的数据压入其中
            }
            ;
            ctx.fillStyle = capStyle;
            //开始绘制帽头
            if (value < capYPositionArray[i]) { //如果当前值小于之前值
                ctx.fillRect(i * 12, cheight - (--capYPositionArray[i]), meterWidth, capHeight); //则使用前一次保存的值来绘制帽头
            } else {
                ctx.fillRect(i * 12, cheight - value, meterWidth, capHeight); //否则使用当前值直接绘制
                capYPositionArray[i] = value;
            };
            //开始绘制频谱条
            ctx.fillStyle = '#f82466';
            ctx.fillRect(i * 12, cheight - value + capHeight, meterWidth, cheight);
        }
        requestAnimationFrame(drawMeter);
      }
      requestAnimationFrame(drawMeter);
    }
}


// WEBPACK FOOTER //
// ./src/utils/audio-vis/index.js